import React from 'react';
import { DetailFormMethodProps } from '.';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import Summary from './Summary';

const DetailFormMethod: React.FC<DetailFormMethodProps> = ({
  notes,
  notesExpectation,
  data,
  title,
  type = 'rater'
}) => {
  return (
    <div className="container-detail-method">
      <Header title={title} type={type} />
      <Body data={data} type={type} />
      <Footer
        data={data}
        type={type}
        notes={notes}
        notesExpectation={notesExpectation}
      />
      <Summary data={data} type={type} />
    </div>
  );
};

export default DetailFormMethod;
